// TODO: this file is actually about 22 KB, contributing significantly to bundle size of this chunk.
// Chunk is already code-split out, but this could/should still be made more efficient.
const d = [
	{
		code: 'AED',
		number: 784.0,
		digits_after_separator: '2',
		currency_name: 'United Arab Emirates dirham',
		country_name: 'United Arab Emirates',
	},
	{
		code: 'AFN',
		number: 971.0,
		digits_after_separator: '2',
		currency_name: 'Afghan afghani',
		country_name: 'Afghanistan',
	},
	{
		code: 'ALL',
		number: 8.0,
		digits_after_separator: '2',
		currency_name: 'Albanian lek',
		country_name: 'Albania',
	},
	{
		code: 'AMD',
		number: 51.0,
		digits_after_separator: '2',
		currency_name: 'Armenian dram',
		country_name: 'Armenia',
	},
	{
		code: 'ANG',
		number: 532.0,
		digits_after_separator: '2',
		currency_name: 'Netherlands Antillean guilder',
		country_name: 'Curaçao (CW),  Sint Maarten (SX)',
	},
	{
		code: 'AOA',
		number: 973.0,
		digits_after_separator: '2',
		currency_name: 'Angolan kwanza',
		country_name: 'Angola',
	},
	{
		code: 'ARS',
		number: 32.0,
		digits_after_separator: '2',
		currency_name: 'Argentine peso',
		country_name: 'Argentina',
	},
	{
		code: 'AUD',
		number: 36.0,
		digits_after_separator: '2',
		currency_name: 'Australian dollar',
		country_name:
			'Australia,  Christmas Island (CX),  Cocos (Keeling) Islands (CC),  Heard Island and McDonald Islands (HM),  Kiribati (KI),  Nauru (NR),  Norfolk Island (NF),  Tuvalu (TV)',
	},
	{
		code: 'AWG',
		number: 533.0,
		digits_after_separator: '2',
		currency_name: 'Aruban florin',
		country_name: 'Aruba',
	},
	{
		code: 'AZN',
		number: 944.0,
		digits_after_separator: '2',
		currency_name: 'Azerbaijani manat',
		country_name: 'Azerbaijan',
	},
	{
		code: 'BAM',
		number: 977.0,
		digits_after_separator: '2',
		currency_name: 'Bosnia and Herzegovina convertible mark',
		country_name: 'Bosnia and Herzegovina',
	},
	{
		code: 'BBD',
		number: 52.0,
		digits_after_separator: '2',
		currency_name: 'Barbados dollar',
		country_name: 'Barbados',
	},
	{
		code: 'BDT',
		number: 50.0,
		digits_after_separator: '2',
		currency_name: 'Bangladeshi taka',
		country_name: 'Bangladesh',
	},
	{
		code: 'BGN',
		number: 975.0,
		digits_after_separator: '2',
		currency_name: 'Bulgarian lev',
		country_name: 'Bulgaria',
	},
	{
		code: 'BHD',
		number: 48.0,
		digits_after_separator: '3',
		currency_name: 'Bahraini dinar',
		country_name: 'Bahrain',
	},
	{
		code: 'BIF',
		number: 108.0,
		digits_after_separator: '0',
		currency_name: 'Burundian franc',
		country_name: 'Burundi',
	},
	{
		code: 'BMD',
		number: 60.0,
		digits_after_separator: '2',
		currency_name: 'Bermudian dollar',
		country_name: 'Bermuda',
	},
	{
		code: 'BND',
		number: 96.0,
		digits_after_separator: '2',
		currency_name: 'Brunei dollar',
		country_name: 'Brunei',
	},
	{
		code: 'BOB',
		number: 68.0,
		digits_after_separator: '2',
		currency_name: 'Boliviano',
		country_name: 'Bolivia',
	},
	{
		code: 'BOV',
		number: 984.0,
		digits_after_separator: '2',
		currency_name: 'Bolivian Mvdol (funds code)',
		country_name: 'Bolivia',
	},
	{
		code: 'BRL',
		number: 986.0,
		digits_after_separator: '2',
		currency_name: 'Brazilian real',
		country_name: 'Brazil',
	},
	{
		code: 'BSD',
		number: 44.0,
		digits_after_separator: '2',
		currency_name: 'Bahamian dollar',
		country_name: 'Bahamas',
	},
	{
		code: 'BTN',
		number: 64.0,
		digits_after_separator: '2',
		currency_name: 'Bhutanese ngultrum',
		country_name: 'Bhutan',
	},
	{
		code: 'BWP',
		number: 72.0,
		digits_after_separator: '2',
		currency_name: 'Botswana pula',
		country_name: 'Botswana',
	},
	{
		code: 'BYN',
		number: 933.0,
		digits_after_separator: '2',
		currency_name: 'Belarusian ruble',
		country_name: 'Belarus',
	},
	{
		code: 'BZD',
		number: 84.0,
		digits_after_separator: '2',
		currency_name: 'Belize dollar',
		country_name: 'Belize',
	},
	{
		code: 'CAD',
		number: 124.0,
		digits_after_separator: '2',
		currency_name: 'Canadian dollar',
		country_name: 'Canada',
	},
	{
		code: 'CDF',
		number: 976.0,
		digits_after_separator: '2',
		currency_name: 'Congolese franc',
		country_name: 'Democratic Republic of the Congo',
	},
	{
		code: 'CHE',
		number: 947.0,
		digits_after_separator: '2',
		currency_name: 'WIR euro (complementary currency)',
		country_name: 'Switzerland',
	},
	{
		code: 'CHF',
		number: 756.0,
		digits_after_separator: '2',
		currency_name: 'Swiss franc',
		country_name: 'Switzerland,  Liechtenstein (LI)',
	},
	{
		code: 'CHW',
		number: 948.0,
		digits_after_separator: '2',
		currency_name: 'WIR franc (complementary currency)',
		country_name: 'Switzerland',
	},
	{
		code: 'CLF',
		number: 990.0,
		digits_after_separator: '4',
		currency_name: 'Unidad de Fomento (funds code)',
		country_name: 'Chile',
	},
	{
		code: 'CLP',
		number: 152.0,
		digits_after_separator: '0',
		currency_name: 'Chilean peso',
		country_name: 'Chile',
	},
	{
		code: 'CNY',
		number: 156.0,
		digits_after_separator: '2',
		currency_name: 'Chinese yuan[8]',
		country_name: 'China',
	},
	{
		code: 'COP',
		number: 170.0,
		digits_after_separator: '2',
		currency_name: 'Colombian peso',
		country_name: 'Colombia',
	},
	{
		code: 'COU',
		number: 970.0,
		digits_after_separator: '2[9]',
		currency_name: 'Unidad de Valor Real (UVR) (funds code)[9]',
		country_name: 'Colombia',
	},
	{
		code: 'CRC',
		number: 188.0,
		digits_after_separator: '2',
		currency_name: 'Costa Rican colon',
		country_name: 'Costa Rica',
	},
	{
		code: 'CUC',
		number: 931.0,
		digits_after_separator: '2',
		currency_name: 'Cuban convertible peso',
		country_name: 'Cuba',
	},
	{
		code: 'CUP',
		number: 192.0,
		digits_after_separator: '2',
		currency_name: 'Cuban peso',
		country_name: 'Cuba',
	},
	{
		code: 'CVE',
		number: 132.0,
		digits_after_separator: '2',
		currency_name: 'Cape Verdean escudo',
		country_name: 'Cabo Verde',
	},
	{
		code: 'CZK',
		number: 203.0,
		digits_after_separator: '2',
		currency_name: 'Czech koruna',
		country_name: 'Czechia [10]',
	},
	{
		code: 'DJF',
		number: 262.0,
		digits_after_separator: '0',
		currency_name: 'Djiboutian franc',
		country_name: 'Djibouti',
	},
	{
		code: 'DKK',
		number: 208.0,
		digits_after_separator: '2',
		currency_name: 'Danish krone',
		country_name: 'Denmark,  Faroe Islands (FO),  Greenland (GL)',
	},
	{
		code: 'DOP',
		number: 214.0,
		digits_after_separator: '2',
		currency_name: 'Dominican peso',
		country_name: 'Dominican Republic',
	},
	{
		code: 'DZD',
		number: 12.0,
		digits_after_separator: '2',
		currency_name: 'Algerian dinar',
		country_name: 'Algeria',
	},
	{
		code: 'EGP',
		number: 818.0,
		digits_after_separator: '2',
		currency_name: 'Egyptian pound',
		country_name: 'Egypt',
	},
	{
		code: 'ERN',
		number: 232.0,
		digits_after_separator: '2',
		currency_name: 'Eritrean nakfa',
		country_name: 'Eritrea',
	},
	{
		code: 'ETB',
		number: 230.0,
		digits_after_separator: '2',
		currency_name: 'Ethiopian birr',
		country_name: 'Ethiopia',
	},
	{
		code: 'EUR',
		number: 978.0,
		digits_after_separator: '2',
		currency_name: 'Euro',
		country_name:
			'Åland Islands (AX),  European Union (EU),  Andorra (AD),  Austria (AT),  Belgium (BE),  Cyprus (CY),  Estonia (EE),  Finland (FI),  France (FR),  French Southern and Antarctic Lands (TF),  Germany (DE),  Greece (GR),  Guadeloupe (GP),  Ireland (IE),  Italy (IT),  Latvia (LV),  Lithuania (LT),  Luxembourg (LU),  Malta (MT),  French Guiana (GF),  Martinique (MQ),  Mayotte (YT),  Monaco (MC),  Montenegro (ME),  Netherlands (NL),  Portugal (PT),  Réunion (RE),  Saint Barthélemy (BL),  Saint Martin (MF),  Saint Pierre and Miquelon (PM),  San Marino (SM),  Slovakia (SK),  Slovenia (SI),  Spain (ES),  Vatican City (VA)',
	},
	{
		code: 'FJD',
		number: 242.0,
		digits_after_separator: '2',
		currency_name: 'Fiji dollar',
		country_name: 'Fiji',
	},
	{
		code: 'FKP',
		number: 238.0,
		digits_after_separator: '2',
		currency_name: 'Falkland Islands pound',
		country_name: 'Falkland Islands (pegged to GBP 1:1)',
	},
	{
		code: 'GBP',
		number: 826.0,
		digits_after_separator: '2',
		currency_name: 'Pound sterling',
		country_name:
			'United Kingdom,  Isle of Man (IM, see Manx pound),  Jersey (JE, see Jersey pound),  Guernsey (GG, see Guernsey pound),  Tristan da Cunha (SH-TA)',
	},
	{
		code: 'GEL',
		number: 981.0,
		digits_after_separator: '2',
		currency_name: 'Georgian lari',
		country_name: 'Georgia',
	},
	{
		code: 'GHS',
		number: 936.0,
		digits_after_separator: '2',
		currency_name: 'Ghanaian cedi',
		country_name: 'Ghana',
	},
	{
		code: 'GIP',
		number: 292.0,
		digits_after_separator: '2',
		currency_name: 'Gibraltar pound',
		country_name: 'Gibraltar (pegged to GBP 1:1)',
	},
	{
		code: 'GMD',
		number: 270.0,
		digits_after_separator: '2',
		currency_name: 'Gambian dalasi',
		country_name: 'Gambia',
	},
	{
		code: 'GNF',
		number: 324.0,
		digits_after_separator: '0',
		currency_name: 'Guinean franc',
		country_name: 'Guinea',
	},
	{
		code: 'GTQ',
		number: 320.0,
		digits_after_separator: '2',
		currency_name: 'Guatemalan quetzal',
		country_name: 'Guatemala',
	},
	{
		code: 'GYD',
		number: 328.0,
		digits_after_separator: '2',
		currency_name: 'Guyanese dollar',
		country_name: 'Guyana',
	},
	{
		code: 'HKD',
		number: 344.0,
		digits_after_separator: '2',
		currency_name: 'Hong Kong dollar',
		country_name: 'Hong Kong',
	},
	{
		code: 'HNL',
		number: 340.0,
		digits_after_separator: '2',
		currency_name: 'Honduran lempira',
		country_name: 'Honduras',
	},
	{
		code: 'HRK',
		number: 191.0,
		digits_after_separator: '2',
		currency_name: 'Croatian kuna',
		country_name: 'Croatia',
	},
	{
		code: 'HTG',
		number: 332.0,
		digits_after_separator: '2',
		currency_name: 'Haitian gourde',
		country_name: 'Haiti',
	},
	{
		code: 'HUF',
		number: 348.0,
		digits_after_separator: '2',
		currency_name: 'Hungarian forint',
		country_name: 'Hungary',
	},
	{
		code: 'IDR',
		number: 360.0,
		digits_after_separator: '2',
		currency_name: 'Indonesian rupiah',
		country_name: 'Indonesia',
	},
	{
		code: 'ILS',
		number: 376.0,
		digits_after_separator: '2',
		currency_name: 'Israeli new shekel',
		country_name: 'Israel',
	},
	{
		code: 'INR',
		number: 356.0,
		digits_after_separator: '2',
		currency_name: 'Indian rupee',
		country_name: 'India,  Bhutan',
	},
	{
		code: 'IQD',
		number: 368.0,
		digits_after_separator: '3',
		currency_name: 'Iraqi dinar',
		country_name: 'Iraq',
	},
	{
		code: 'IRR',
		number: 364.0,
		digits_after_separator: '2',
		currency_name: 'Iranian rial',
		country_name: 'Iran',
	},
	{
		code: 'ISK',
		number: 352.0,
		digits_after_separator: '0',
		currency_name: 'Icelandic króna (plural: krónur)',
		country_name: 'Iceland',
	},
	{
		code: 'JMD',
		number: 388.0,
		digits_after_separator: '2',
		currency_name: 'Jamaican dollar',
		country_name: 'Jamaica',
	},
	{
		code: 'JOD',
		number: 400.0,
		digits_after_separator: '3',
		currency_name: 'Jordanian dinar',
		country_name: 'Jordan',
	},
	{
		code: 'JPY',
		number: 392.0,
		digits_after_separator: '0',
		currency_name: 'Japanese yen',
		country_name: 'Japan',
	},
	{
		code: 'KES',
		number: 404.0,
		digits_after_separator: '2',
		currency_name: 'Kenyan shilling',
		country_name: 'Kenya',
	},
	{
		code: 'KGS',
		number: 417.0,
		digits_after_separator: '2',
		currency_name: 'Kyrgyzstani som',
		country_name: 'Kyrgyzstan',
	},
	{
		code: 'KHR',
		number: 116.0,
		digits_after_separator: '2',
		currency_name: 'Cambodian riel',
		country_name: 'Cambodia',
	},
	{
		code: 'KMF',
		number: 174.0,
		digits_after_separator: '0',
		currency_name: 'Comoro franc',
		country_name: 'Comoros',
	},
	{
		code: 'KPW',
		number: 408.0,
		digits_after_separator: '2',
		currency_name: 'North Korean won',
		country_name: 'North Korea',
	},
	{
		code: 'KRW',
		number: 410.0,
		digits_after_separator: '0[c]',
		currency_name: 'South Korean won',
		country_name: 'South Korea',
	},
	{
		code: 'KWD',
		number: 414.0,
		digits_after_separator: '3',
		currency_name: 'Kuwaiti dinar',
		country_name: 'Kuwait',
	},
	{
		code: 'KYD',
		number: 136.0,
		digits_after_separator: '2',
		currency_name: 'Cayman Islands dollar',
		country_name: 'Cayman Islands',
	},
	{
		code: 'KZT',
		number: 398.0,
		digits_after_separator: '2',
		currency_name: 'Kazakhstani tenge',
		country_name: 'Kazakhstan',
	},
	{
		code: 'LAK',
		number: 418.0,
		digits_after_separator: '2',
		currency_name: 'Lao kip',
		country_name: 'Laos',
	},
	{
		code: 'LBP',
		number: 422.0,
		digits_after_separator: '2',
		currency_name: 'Lebanese pound',
		country_name: 'Lebanon',
	},
	{
		code: 'LKR',
		number: 144.0,
		digits_after_separator: '2',
		currency_name: 'Sri Lankan rupee',
		country_name: 'Sri Lanka',
	},
	{
		code: 'LRD',
		number: 430.0,
		digits_after_separator: '2',
		currency_name: 'Liberian dollar',
		country_name: 'Liberia',
	},
	{
		code: 'LSL',
		number: 426.0,
		digits_after_separator: '2',
		currency_name: 'Lesotho loti',
		country_name: 'Lesotho',
	},
	{
		code: 'LYD',
		number: 434.0,
		digits_after_separator: '3',
		currency_name: 'Libyan dinar',
		country_name: 'Libya',
	},
	{
		code: 'MAD',
		number: 504.0,
		digits_after_separator: '2',
		currency_name: 'Moroccan dirham',
		country_name: 'Morocco,  Western Sahara',
	},
	{
		code: 'MDL',
		number: 498.0,
		digits_after_separator: '2',
		currency_name: 'Moldovan leu',
		country_name: 'Moldova',
	},
	{
		code: 'MGA',
		number: 969.0,
		digits_after_separator: '2[d]',
		currency_name: 'Malagasy ariary',
		country_name: 'Madagascar',
	},
	{
		code: 'MKD',
		number: 807.0,
		digits_after_separator: '2',
		currency_name: 'Macedonian denar',
		country_name: 'North Macedonia',
	},
	{
		code: 'MMK',
		number: 104.0,
		digits_after_separator: '2',
		currency_name: 'Myanmar kyat',
		country_name: 'Myanmar',
	},
	{
		code: 'MNT',
		number: 496.0,
		digits_after_separator: '2',
		currency_name: 'Mongolian tögrög',
		country_name: 'Mongolia',
	},
	{
		code: 'MOP',
		number: 446.0,
		digits_after_separator: '2',
		currency_name: 'Macanese pataca',
		country_name: 'Macau',
	},
	{
		code: 'MRU[12]',
		number: 929.0,
		digits_after_separator: '2[d]',
		currency_name: 'Mauritanian ouguiya',
		country_name: 'Mauritania',
	},
	{
		code: 'MUR',
		number: 480.0,
		digits_after_separator: '2',
		currency_name: 'Mauritian rupee',
		country_name: 'Mauritius',
	},
	{
		code: 'MVR',
		number: 462.0,
		digits_after_separator: '2',
		currency_name: 'Maldivian rufiyaa',
		country_name: 'Maldives',
	},
	{
		code: 'MWK',
		number: 454.0,
		digits_after_separator: '2',
		currency_name: 'Malawian kwacha',
		country_name: 'Malawi',
	},
	{
		code: 'MXN',
		number: 484.0,
		digits_after_separator: '2',
		currency_name: 'Mexican peso',
		country_name: 'Mexico',
	},
	{
		code: 'MXV',
		number: 979.0,
		digits_after_separator: '2',
		currency_name: 'Mexican Unidad de Inversion (UDI) (funds code)',
		country_name: 'Mexico',
	},
	{
		code: 'MYR',
		number: 458.0,
		digits_after_separator: '2',
		currency_name: 'Malaysian ringgit',
		country_name: 'Malaysia',
	},
	{
		code: 'MZN',
		number: 943.0,
		digits_after_separator: '2',
		currency_name: 'Mozambican metical',
		country_name: 'Mozambique',
	},
	{
		code: 'NAD',
		number: 516.0,
		digits_after_separator: '2',
		currency_name: 'Namibian dollar',
		country_name: 'Namibia',
	},
	{
		code: 'NGN',
		number: 566.0,
		digits_after_separator: '2',
		currency_name: 'Nigerian naira',
		country_name: 'Nigeria',
	},
	{
		code: 'NIO',
		number: 558.0,
		digits_after_separator: '2',
		currency_name: 'Nicaraguan córdoba',
		country_name: 'Nicaragua',
	},
	{
		code: 'NOK',
		number: 578.0,
		digits_after_separator: '2',
		currency_name: 'Norwegian krone',
		country_name:
			'Norway,  Svalbard and  Jan Mayen (SJ),  Bouvet Island (BV)',
	},
	{
		code: 'NPR',
		number: 524.0,
		digits_after_separator: '2',
		currency_name: 'Nepalese rupee',
		country_name: 'Nepal',
	},
	{
		code: 'NZD',
		number: 554.0,
		digits_after_separator: '2',
		currency_name: 'New Zealand dollar',
		country_name:
			'New Zealand,  Cook Islands (CK),  Niue (NU),  Pitcairn Islands (PN; see also Pitcairn Islands dollar),  Tokelau (TK)',
	},
	{
		code: 'OMR',
		number: 512.0,
		digits_after_separator: '3',
		currency_name: 'Omani rial',
		country_name: 'Oman',
	},
	{
		code: 'PAB',
		number: 590.0,
		digits_after_separator: '2',
		currency_name: 'Panamanian balboa',
		country_name: 'Panama',
	},
	{
		code: 'PEN',
		number: 604.0,
		digits_after_separator: '2',
		currency_name: 'Peruvian sol',
		country_name: 'Peru',
	},
	{
		code: 'PGK',
		number: 598.0,
		digits_after_separator: '2',
		currency_name: 'Papua New Guinean kina',
		country_name: 'Papua New Guinea',
	},
	{
		code: 'PHP',
		number: 608.0,
		digits_after_separator: '2',
		currency_name: 'Philippine peso[13]',
		country_name: 'Philippines',
	},
	{
		code: 'PKR',
		number: 586.0,
		digits_after_separator: '2',
		currency_name: 'Pakistani rupee',
		country_name: 'Pakistan',
	},
	{
		code: 'PLN',
		number: 985.0,
		digits_after_separator: '2',
		currency_name: 'Polish złoty',
		country_name: 'Poland',
	},
	{
		code: 'PYG',
		number: 600.0,
		digits_after_separator: '0',
		currency_name: 'Paraguayan guaraní',
		country_name: 'Paraguay',
	},
	{
		code: 'QAR',
		number: 634.0,
		digits_after_separator: '2',
		currency_name: 'Qatari riyal',
		country_name: 'Qatar',
	},
	{
		code: 'RON',
		number: 946.0,
		digits_after_separator: '2',
		currency_name: 'Romanian leu',
		country_name: 'Romania',
	},
	{
		code: 'RSD',
		number: 941.0,
		digits_after_separator: '2',
		currency_name: 'Serbian dinar',
		country_name: 'Serbia',
	},
	{
		code: 'RUB',
		number: 643.0,
		digits_after_separator: '2',
		currency_name: 'Russian ruble',
		country_name: 'Russia',
	},
	{
		code: 'RWF',
		number: 646.0,
		digits_after_separator: '0',
		currency_name: 'Rwandan franc',
		country_name: 'Rwanda',
	},
	{
		code: 'SAR',
		number: 682.0,
		digits_after_separator: '2',
		currency_name: 'Saudi riyal',
		country_name: 'Saudi Arabia',
	},
	{
		code: 'SBD',
		number: 90.0,
		digits_after_separator: '2',
		currency_name: 'Solomon Islands dollar',
		country_name: 'Solomon Islands',
	},
	{
		code: 'SCR',
		number: 690.0,
		digits_after_separator: '2',
		currency_name: 'Seychelles rupee',
		country_name: 'Seychelles',
	},
	{
		code: 'SDG',
		number: 938.0,
		digits_after_separator: '2',
		currency_name: 'Sudanese pound',
		country_name: 'Sudan',
	},
	{
		code: 'SEK',
		number: 752.0,
		digits_after_separator: '2',
		currency_name: 'Swedish krona (plural: kronor)',
		country_name: 'Sweden',
	},
	{
		code: 'SGD',
		number: 702.0,
		digits_after_separator: '2',
		currency_name: 'Singapore dollar',
		country_name: 'Singapore',
	},
	{
		code: 'SHP',
		number: 654.0,
		digits_after_separator: '2',
		currency_name: 'Saint Helena pound',
		country_name: 'Saint Helena (SH-SH),  Ascension Island (SH-AC)',
	},
	{
		code: 'SLL',
		number: 694.0,
		digits_after_separator: '2',
		currency_name: 'Sierra Leonean leone',
		country_name: 'Sierra Leone',
	},
	{
		code: 'SOS',
		number: 706.0,
		digits_after_separator: '2',
		currency_name: 'Somali shilling',
		country_name: 'Somalia',
	},
	{
		code: 'SRD',
		number: 968.0,
		digits_after_separator: '2',
		currency_name: 'Surinamese dollar',
		country_name: 'Suriname',
	},
	{
		code: 'SSP',
		number: 728.0,
		digits_after_separator: '2',
		currency_name: 'South Sudanese pound',
		country_name: 'South Sudan',
	},
	{
		code: 'STN[14]',
		number: 930.0,
		digits_after_separator: '2',
		currency_name: 'São Tomé and Príncipe dobra',
		country_name: 'São Tomé and Príncipe',
	},
	{
		code: 'SVC',
		number: 222.0,
		digits_after_separator: '2',
		currency_name: 'Salvadoran colón',
		country_name: 'El Salvador',
	},
	{
		code: 'SYP',
		number: 760.0,
		digits_after_separator: '2',
		currency_name: 'Syrian pound',
		country_name: 'Syria',
	},
	{
		code: 'SZL',
		number: 748.0,
		digits_after_separator: '2',
		currency_name: 'Swazi lilangeni',
		country_name: 'Eswatini[13]',
	},
	{
		code: 'THB',
		number: 764.0,
		digits_after_separator: '2',
		currency_name: 'Thai baht',
		country_name: 'Thailand',
	},
	{
		code: 'TJS',
		number: 972.0,
		digits_after_separator: '2',
		currency_name: 'Tajikistani somoni',
		country_name: 'Tajikistan',
	},
	{
		code: 'TMT',
		number: 934.0,
		digits_after_separator: '2',
		currency_name: 'Turkmenistan manat',
		country_name: 'Turkmenistan',
	},
	{
		code: 'TND',
		number: 788.0,
		digits_after_separator: '3',
		currency_name: 'Tunisian dinar',
		country_name: 'Tunisia',
	},
	{
		code: 'TOP',
		number: 776.0,
		digits_after_separator: '2',
		currency_name: 'Tongan paʻanga',
		country_name: 'Tonga',
	},
	{
		code: 'TRY',
		number: 949.0,
		digits_after_separator: '2',
		currency_name: 'Turkish lira',
		country_name: 'Turkey',
	},
	{
		code: 'TTD',
		number: 780.0,
		digits_after_separator: '2',
		currency_name: 'Trinidad and Tobago dollar',
		country_name: 'Trinidad and Tobago',
	},
	{
		code: 'TWD',
		number: 901.0,
		digits_after_separator: '2',
		currency_name: 'New Taiwan dollar',
		country_name: 'Taiwan',
	},
	{
		code: 'TZS',
		number: 834.0,
		digits_after_separator: '2',
		currency_name: 'Tanzanian shilling',
		country_name: 'Tanzania',
	},
	{
		code: 'UAH',
		number: 980.0,
		digits_after_separator: '2',
		currency_name: 'Ukrainian hryvnia',
		country_name: 'Ukraine',
	},
	{
		code: 'UGX',
		number: 800.0,
		digits_after_separator: '0',
		currency_name: 'Ugandan shilling',
		country_name: 'Uganda',
	},
	{
		code: 'USD',
		number: 840.0,
		digits_after_separator: '2',
		currency_name: 'United States dollar',
		country_name:
			'United States,  American Samoa (AS),  British Indian Ocean Territory (IO) (also uses GBP),  British Virgin Islands (VG),  Caribbean Netherlands (BQ – Bonaire, Sint Eustatius and Saba),  Ecuador (EC),  El Salvador (SV),  Guam (GU),  Marshall Islands (MH),  Federated States of Micronesia (FM),  Northern Mariana Islands (MP),  Palau (PW),  Panama (PA) (as well as Panamanian Balboa),  Puerto Rico (PR),  Timor-Leste (TL),  Turks and Caicos Islands (TC),  U.S. Virgin Islands (VI),  United States Minor Outlying Islands (UM)',
	},
	{
		code: 'USN',
		number: 997.0,
		digits_after_separator: '2',
		currency_name: 'United States dollar (next day) (funds code)',
		country_name: 'United States',
	},
	{
		code: 'UYI',
		number: 940.0,
		digits_after_separator: '0',
		currency_name:
			'Uruguay Peso en Unidades Indexadas (URUIURUI) (funds code)',
		country_name: 'Uruguay',
	},
	{
		code: 'UYU',
		number: 858.0,
		digits_after_separator: '2',
		currency_name: 'Uruguayan peso',
		country_name: 'Uruguay',
	},
	{
		code: 'UYW',
		number: 927.0,
		digits_after_separator: '4',
		currency_name: 'Unidad previsional[15]',
		country_name: 'Uruguay',
	},
	{
		code: 'UZS',
		number: 860.0,
		digits_after_separator: '2',
		currency_name: 'Uzbekistan som',
		country_name: 'Uzbekistan',
	},
	{
		code: 'VED',
		number: 926.0,
		digits_after_separator: '2',
		currency_name: 'Venezuelan bolívar digital[16]',
		country_name: 'Venezuela',
	},
	{
		code: 'VES',
		number: 928.0,
		digits_after_separator: '2',
		currency_name: 'Venezuelan bolívar soberano[13]',
		country_name: 'Venezuela',
	},
	{
		code: 'VND',
		number: 704.0,
		digits_after_separator: '0',
		currency_name: 'Vietnamese đồng',
		country_name: 'Vietnam',
	},
	{
		code: 'VUV',
		number: 548.0,
		digits_after_separator: '0',
		currency_name: 'Vanuatu vatu',
		country_name: 'Vanuatu',
	},
	{
		code: 'WST',
		number: 882.0,
		digits_after_separator: '2',
		currency_name: 'Samoan tala',
		country_name: 'Samoa',
	},
	{
		code: 'XAF',
		number: 950.0,
		digits_after_separator: '0',
		currency_name: 'CFA franc BEAC',
		country_name:
			'Cameroon (CM),  Central African Republic (CF),  Republic of the Congo (CG),  Chad (TD),  Equatorial Guinea (GQ),  Gabon (GA)',
	},
	{
		code: 'XAG',
		number: 961.0,
		digits_after_separator: null,
		currency_name: 'Silver (one troy ounce)',
		country_name: null,
	},
	{
		code: 'XAU',
		number: 959.0,
		digits_after_separator: null,
		currency_name: 'Gold (one troy ounce)',
		country_name: null,
	},
	{
		code: 'XBA',
		number: 955.0,
		digits_after_separator: null,
		currency_name: 'European Composite Unit (EURCO) (bond market unit)',
		country_name: null,
	},
	{
		code: 'XBB',
		number: 956.0,
		digits_after_separator: null,
		currency_name: 'European Monetary Unit (E.M.U.-6) (bond market unit)',
		country_name: null,
	},
	{
		code: 'XBC',
		number: 957.0,
		digits_after_separator: null,
		currency_name:
			'European Unit of Account 9 (E.U.A.-9) (bond market unit)',
		country_name: null,
	},
	{
		code: 'XBD',
		number: 958.0,
		digits_after_separator: null,
		currency_name:
			'European Unit of Account 17 (E.U.A.-17) (bond market unit)',
		country_name: null,
	},
	{
		code: 'XCD',
		number: 951.0,
		digits_after_separator: '2',
		currency_name: 'East Caribbean dollar',
		country_name:
			'Anguilla (AI),  Antigua and Barbuda (AG),  Dominica (DM),  Grenada (GD),  Montserrat (MS),  Saint Kitts and Nevis (KN),  Saint Lucia (LC),  Saint Vincent and the Grenadines (VC)',
	},
	{
		code: 'XDR',
		number: 960.0,
		digits_after_separator: null,
		currency_name: 'Special drawing rights',
		country_name: 'International Monetary Fund',
	},
	{
		code: 'XOF',
		number: 952.0,
		digits_after_separator: '0',
		currency_name: 'CFA franc BCEAO',
		country_name:
			"Benin (BJ),  Burkina Faso (BF),  Côte d'Ivoire (CI),  Guinea-Bissau (GW),  Mali (ML),  Niger (NE),  Senegal (SN),  Togo (TG)",
	},
	{
		code: 'XPD',
		number: 964.0,
		digits_after_separator: null,
		currency_name: 'Palladium (one troy ounce)',
		country_name: null,
	},
	{
		code: 'XPF',
		number: 953.0,
		digits_after_separator: '0',
		currency_name: 'CFP franc (franc Pacifique)',
		country_name:
			'French territories of the Pacific Ocean:  French Polynesia (PF),  New Caledonia (NC),  Wallis and Futuna (WF)',
	},
	{
		code: 'XPT',
		number: 962.0,
		digits_after_separator: null,
		currency_name: 'Platinum (one troy ounce)',
		country_name: null,
	},
	{
		code: 'XSU',
		number: 994.0,
		digits_after_separator: null,
		currency_name: 'SUCRE',
		country_name: 'Unified System for Regional Compensation (SUCRE)[17]',
	},
	{
		code: 'XTS',
		number: 963.0,
		digits_after_separator: null,
		currency_name: 'Code reserved for testing',
		country_name: null,
	},
	{
		code: 'XUA',
		number: 965.0,
		digits_after_separator: null,
		currency_name: 'ADB Unit of Account',
		country_name: 'African Development Bank[18]',
	},
	{
		code: 'XXX',
		number: 999.0,
		digits_after_separator: null,
		currency_name: 'No currency',
		country_name: null,
	},
	{
		code: 'YER',
		number: 886.0,
		digits_after_separator: '2',
		currency_name: 'Yemeni rial',
		country_name: 'Yemen',
	},
	{
		code: 'ZAR',
		number: 710.0,
		digits_after_separator: '2',
		currency_name: 'South African rand',
		country_name: 'Eswatini,  Lesotho,  Namibia,  South Africa',
	},
	{
		code: 'ZMW',
		number: 967.0,
		digits_after_separator: '2',
		currency_name: 'Zambian kwacha',
		country_name: 'Zambia',
	},
	{
		code: 'ZWL',
		number: 932.0,
		digits_after_separator: '2',
		currency_name: 'Zimbabwean dollar',
		country_name: 'Zimbabwe',
	},
];

export default d;
